// Select terms synchronously for new page loads. Deploy the compatible backend
// first: /payment accepts both fixed offers so already-open pages can finish.
export const TRIAL_PAYMENT_MODE = 'all'; // standard | campaigns | all

export const SPLIT_TRIAL_CAMPAIGNS = Object.freeze([
  'Pinterest_110526_EN_CPA_PerfMax_Checkout_hairstyle_[top_organic]',
  'Pinterest_100626_EN_CPA_PerfMax_Checkout_hairstyle_pack4',
  'Pinterest_280426_EN_CPA_PerfMax_Checkout_haircolor_byskintone',
  'Pinterest_250526_EN_CPA_PerfMax_Checkout_hairstyle_pack2_reworks',
  'Pinterest_280426_EN_CPA_PerfMax_Checkout_bodytype',
  'Pinterest_100426_EN_CPA_PerfMax_Checkout_hairstyle_pack3',
  'Pinterest_210526_US_CPA_PerfMax_Checkout_hairstyle_pack2_d1',
  'Pinterest_040626_EN_CPA_PerfMax_Checkout_hairstyle_toporgmay',
  'Pinterest_*', // Reserved rule: case-sensitive Pinterest_ prefix; no general glob matching.
]);

export const SPLIT_TRIAL_PAYWALLS = Object.freeze([
  'colortype-3month-29', 'colortype-3month-29-upsell', 'colortype-1month-29',
  'glasses-3month-29-upsell-v2', 'sunglasses-3month-29-upsell-v2', 'makeup-3month-29-upsell-v2',
  'haircolor-3month-29', 'haircolor-recomend-3month-29', 'hairstyle-3month-29-woman',
  'bodytype-3month-29-woman', 'wedding-guest-3month-29-woman', 'hairstyle-3month-29-man',
  'faceshape-3month-29', 'main', 'v2',
]);

export function getLocalTrialOffer(base, paywall, campaign, mode = TRIAL_PAYMENT_MODE) {
  const supportedTrial = ['usd', 'eur'].includes(base.currency) &&
    base.offerId === `trial-${base.currency}-v1` && SPLIT_TRIAL_PAYWALLS.includes(paywall);
  const campaignMatch = typeof campaign === 'string' && campaign.length > 0 && campaign.length <= 500 &&
    (SPLIT_TRIAL_CAMPAIGNS.includes(campaign) ||
      (SPLIT_TRIAL_CAMPAIGNS.includes('Pinterest_*') && campaign.startsWith('Pinterest_')));
  const split = supportedTrial && (mode === 'all' || (mode === 'campaigns' && campaignMatch));
  return {
    offerId: split ? `trial-split-${base.currency}-v1` : base.offerId,
    baseOfferId: base.offerId, currency: base.currency,
    paymentMode: split ? 'split_trial_v1' : 'standard',
    initialAmount: split ? 50 : base.amount, totalAmount: split ? 100 : base.amount,
    followupAmount: split ? 50 : 0, followupDelayMs: split ? 2000 : 0,
  };
}
